<template>
  <v-app id="app">
    <router-view />
    <push-notification />
    <notifications />
    <UpdateMessageBox />
    <DepartmentAlert />
  </v-app>
</template>
<script>
import PushNotification from "@/components/PushNotification";
import UpdateMessageBox from "@/components/UpdateMessageBox";
import DepartmentAlert from "@/components/DepartmentAlert.vue";
import Cookies from "universal-cookie";
import { AUTH_LOGOUT_URL, COOKIE_HOST, IS_DEV, MODE } from "./config";
import TokenService from "@/services/TokenService";

export default {
  components: { UpdateMessageBox, PushNotification, DepartmentAlert },
  created() {
    window.$loadDtHeader({
      currentLang: this.$i18n.locale,
      position: "fixed",
      activeModule: "dwm",
      enableProfileIcon: true,
      mode: MODE,
      enableLanguageSwitcher: true,
      onSelectLanguage: (lang) => {
        this.$i18n.locale = lang;
        const cookies = new Cookies(null);
        const domain = IS_DEV ? null : COOKIE_HOST;
        cookies.set("lang", lang, {
          domain,
          path: "/",
        });
      },
      onLogout: () => {
        TokenService.removeToken();
        window.location.href = AUTH_LOGOUT_URL;
      },
      // onClickProfileIcon: () => {
      //   this.$store.state.user.drawer = !this.$store.state.user.drawer;
      // },
    });
  },
};
</script>
